import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { checkEmail } from '@/utils/validate';
export default {
  props: {
    addEmailVisible: {
      type: Boolean,
      default: false
    },
    addEmailTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      emails: ''
    };
  },
  methods: {
    handleSure() {
      let arr = this.emails.split(',');
      let passValidate = true;
      arr && Array.isArray(arr) && arr.map(item => {
        let value = item.trim();
        value = value.trimEnd();
        if (!checkEmail(value)) {
          this.$message.destroy();
          this.$message.error(this.$t('请输入正确的邮箱地址'));
          passValidate = false;
        }
        return value;
      });
      if (passValidate) {
        this.$emit('cancelAddEmail', arr);
      }
    },
    cancelAdd() {
      this.emails = '';
      this.$emit('cancelAddEmail');
    }
  }
};